import ColumnType from 'lib/enums/columntype';

/**
	* Assume the kind of data column by its name
	* @param {string} column name
	* 
	* @returns {ColumnType} the presumed type
*/
export function assumeColumnKindByName(name:string):ColumnType {
	switch(name) {
		case 'urls':
			return ColumnType.URLs;
		case 'id':
			return ColumnType.ID;
		case 'description':
		case 'html':
		case 'metadata':
			return ColumnType.RichText;
		case 'title':
		case 'name':
			return ColumnType.Text;
		default:
			return ColumnType.Text;
	}
}